import { Row, Col } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const formatNumber = (value) => {
  if (value === null || value === undefined) return "";
  const clean = value.toString().replace(/[^0-9.]/g, ""); // remove commas, $ etc.
  const num = Number(clean);
  if (isNaN(num)) return value; // fallback
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const LawAndEnforcement = () => {
  const tableData = [
    {
      department: "Utah Highway Patrol (UHP) Troopers (Ongoing)",
      amount: "1.3",
      color: "#E5E4E290",
    },
    {
      department: "Utah Highway Patrol (UHP) Troopers (One-Time)",
      amount: "0.9",
      color: "#BCC6CC90",
    },
    {
      department: "State Prison Operations (One-Time)",
      amount: "6.5",
      color: "#357EC790",
    },
    {
      department: "Fentanyl Interdiction (Ongoing)",
      amount: "0.8",
      color: "#E3F9A690",
    },
    {
      department: "Fentanyl Interdiction (One-Time)",
      amount: "0.95",
      color: "#3B9C9C90",
    },
    {
      department: "Attorney General Retention and Capacity (Ongoing)",
      amount: "4.1",
      color: "#FBF6D990",
    },
    {
      department: "Aero Bureau Operations (Ongoing)",
      amount: "0.25",
      color: "#ffa37c90",
    },
    {
      department: "Aero Bureau Operations (One-Time)",
      amount: "1.8",
      color: "#B83C0890",
    },
    {
      department: "Prison Overtime Pay (One-Time)",
      amount: "2",
      color: "#8A9A5B90",
    },
    {
      department: "Juror, Witness, and Interpreter Program (Ongoing)",
      amount: "1.5",
      color: "#ffee9290",
    },
    {
      department: "Juror, Witness, and Interpreter Program (One-Time)",
      amount: "0.45",
      color: "#FFD80190",
    },
    {
      department: "Recruit and Retain Guardian ad Litem Attorneys (Ongoing)",
      amount: "1.1",
      color: "#F4A46090",
    },
    {
      department: "Southern Utah Elder Abuse and Fraud Initiative (Ongoing)",
      amount: "1.04",
      color: "#4863A090",
    },
    {
      department: "Correctional Drug Enforcement Amendments (H.B. 323)",
      amount: "0.3",
      color: "#FFDAB990",
    },
    {
      department: "Drug Trafficking Amendments (H.B. 87) (Ongoing)",
      amount: "0.16",
      color: "#43302E90",
    },
  ];

  const totalAmount = tableData.reduce(
    (sum, row) => sum + Number(row.amount),
    0
  );

  const chartLabels = tableData.map((row) => row.department);
  const chartValues = tableData.map((row) =>
    parseFloat(row.amount.replace(/[^0-9.]/g, ""))
  );
  const chartColors = tableData.map((row) => row.color.replace("90", "")); // solid color

  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        label: "Amount ($ Million)",
        data: chartValues,
        backgroundColor: chartColors, // solid colors
        // border: 1,
        borderRadius: 8,
        barThickness: 15,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    indexAxis: "y", // Horizontal bar
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.label}: ${formatNumber(ctx.raw)}`,
        },
      },
      datalabels: {
        display: true,
        color: "#000",
        anchor: "end",
        align: "right",
        formatter: (value) => formatNumber(value),
        font: { weight: "bold", size: 13 },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Amount ($ Million)",
          color: "#111",
          font: { weight: "bold" },
        },
        ticks: { color: "#333" },
        grid: { display: true, color: "#ddd" },
      },
      y: {
        title: {
          display: true,
          text: "Category/Program",
          color: "#111",
          font: { weight: "bold" },
        },
        ticks: {
          color: "#111",
          font: { size: 12, weight: "500" },
        },
        grid: { display: false },
      },
    },
  };

  return (
    <div className="max-w-7xl mx-auto px-4">
      <h3>
        Law Enforcement Budget Overview ($
        {Number("1500").toLocaleString("en-US")} Million, 5%)
      </h3>{" "}
      <Row className="gy-4 flex items-center">
        {/* Table */}
        <Col md={12}>
          <div className="overflow-x-auto flex items-center">
            <table className="w-full border-collapse text-center border shadow-md overflow-hidden mt-6">
              <thead>
                <tr>
                  <th
                    className="p-2 text-left border"
                    style={{ backgroundColor: "#bfdbfe" }}
                  >
                    Category/Program
                  </th>
                  <th
                    className="p-2 text-right border "
                    style={{ backgroundColor: "#bfdbfe" }}
                  >
                    Amount ($ Million)
                  </th>
                </tr>
              </thead>

              <tbody>
                {tableData.map((row, index) => (
                  <tr
                    key={index}
                    className="odd:bg-gray-100 even:bg-white hover:bg-gray-100 transition border"
                  >
                    <td
                      className="p-2 text-left border"
                      // style={{ backgroundColor: row.color }}
                    >
                      {row.department}
                    </td>
                    <td className="p-2 text-right border">
                      {formatNumber(row.amount)}
                    </td>
                  </tr>
                ))}
                {/* ✅ TOTAL ROW */}
                <tr className="bg-blue-50 font-semibold border-t-2">
                  <td className="p-2 text-left border">Total</td>
                  <td className="p-2 text-right border">
                    {formatNumber(totalAmount)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
        <Col md={12}>
          <div className="overflow-x-auto">
            <div className="p-3 bg-white rounded-3 border min-w-[900px] sm:min-w-full">
              {" "}
              <Bar data={chartData} options={chartOptions} />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LawAndEnforcement;
